// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__k6ZA6","icon":"LogoutButton_icon__4fuo7"};